export default __webpack_public_path__ + "static/media/weeklygoals.6acb1d9e.svg";